import React from 'react';
import { Round } from '../classes/Round';
import { Player } from '../classes/Player';
import { Popups } from '../constants/Popups';
import { RoundPhase } from '../constants/RoundPhase';
import { Stats } from '../classes/Stats';
import { getRedCardIndex } from '../utils/CardsUtils';
import { getRedCardText } from '../utils/TextsUtils';

interface OpenRedCardDialogInterface {
    gameId: string;
    playerId: number;
    statsId: number;
    currentRound: Round;
    judge: Player;
    criminal: Player;
    skipped: boolean;
    popup: Popups;
}

function OpenRedCardDialog({gameId, playerId, statsId, currentRound, judge, criminal, skipped, popup}: OpenRedCardDialogInterface) {
    const announcements = require("../images/announcementsWhite.png");
    const logoWhite = require("../images/logoWhite.png");
    const skippedImage = require("../images/skipped.png");

    const  handlePlayCard = async () => {
        if (!skipped) {
            await Round.updateRoundStatus(gameId, RoundPhase.playBlackCard);
        }
    }

    const  handleSkipCard = async () => {
        if (!skipped) {
            Stats.updateSkippedCards(statsId, currentRound.redCardIdx);
            const redCardIdx = await getRedCardIndex(gameId);
            await Round.updateRound(currentRound.roundId, gameId, currentRound.judge, currentRound.criminal, redCardIdx, RoundPhase.openRedCard);
        }
    }

    return (
        <>
            <div className="openRedCardWrapper">
                {
                    playerId === currentRound.judge
                    ? <>
                        <div className="openRedCardReadCardAloudWrapper">
                            <div className="openRedCardReadCardAloud">Read Card Aloud</div>
                            <img className="openRedCardReadCardAloudIcon" src={announcements} alt="read card aloud"/>
                        </div>
                        <div className="openRedCardText">{getRedCardText(currentRound.redCardIdx, criminal.name, criminal.gender)}</div>
                    </>
                    : <>
                        <div className="openRedCardLogoWrapper">
                            <img className="openRedCardLogo" src={logoWhite} alt="logo"/>
                        </div>
                        {!skipped && <div className="openRedCardInfoMessage">{`${judge.name} (Judge) is reviewing...`}</div>}
                    </>
                }
                
                {playerId === currentRound.judge && !skipped && popup === Popups.none && <div className="openRedCardActionsWrapper">
                    <button className="openRedCardPlayCardButton" onClick={handlePlayCard}>PLAY CARD</button>
                    <button className="openRedCardSkipCardButton" onClick={handleSkipCard}>SKIP CARD</button>
                </div>}
                {/* {playerId !== currentRound.judge && !skipped && <div>{`${judge.name} (Judge) is reviewing...`}</div>} */}
                {skipped && <img className="openRedCardSkippedImage" src={skippedImage} alt="skipped"/>}
                {skipped && <div className="openRedCardSkippedText"> {playerId === currentRound.judge ? "SKIPPED CARD" : "JUDGE SKIPPED CARD"}</div>}
            </div>
        </>
    );
};

export default OpenRedCardDialog;